import React from "react";
import { useParams } from "react-router-dom";
import { motion } from "framer-motion";
import { FaClock, FaMedal, FaGem, FaPenFancy, FaCoins, FaRing, FaCrown } from "react-icons/fa";
import {GiSilverBullet, GiStonePile, GiLaurelCrown, GiDiamonds} from "react-icons/gi";
import styles from "./BrandDetail.module.scss";

export default function BrandDetail() {
  const { brand } = useParams();

  return (
    <div className={styles.watchBrandPage}>
      <div className={styles.backgroundElements}>
        <div className={styles.circle1}></div>
        <div className={styles.circle2}></div>
        <div className={styles.circle3}></div>
        <div className={styles.watchElement}></div>
      </div>

      <div className="container">
        <motion.h1
          className={styles.brandTitle}
          initial={{ opacity: 0, y: -50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, type: "spring" }}
        >
          {brand.replace(/-/g, " ").toUpperCase()}
        </motion.h1>

        <motion.div
          className={styles.textContent}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1 }}
        >
          <h2>Način saradnje</h2>
          <p>Ukoliko nismo u mogućnosti da se lično vidimo i obavimo razmenu uživo, saradnju radim isključivo putem pošiljke.
            Paket mi stiže na adresu, pregledam sadržaj i odmah nakon toga vršim uplatu na račun prodavca.
            Ovaj princip koristim isključivo zbog sigurnosti i izbegavanja mogućih prevara.</p>
          <h2>Nadoknada troškova puta</h2>
          <p>Da bismo našim klijentima izašli u susret, <b>nadoknađujemo troškove goriva</b> svima koji dolaze kod nas, a koji stanuju van Obrenovca, ukoliko saradnja bude realizovana.
            Na ovaj način želimo da pokažemo ozbiljnost i poštovanje prema vremenu i izdacima naših klijenata.</p>
          <h2>Uslovi</h2>
          <p>Uslov da bismo uspešno obavili kupoprodaju je da imaš navršenih 18 godina i da poseduješ važeći dokument sa fotografijom izdat u republici Srbiji (lična karta, pasoš ili vozačka dozvola). Tvoje podatke evidentiramo u skladu sa važećim zakonima republike Srbije.
          </p>
          <h2>Šta sve otkupljujemo?</h2>
          <h2><FaClock className={styles.icon}/> Ručni i džepni satovi</h2>
          <ul>
            <li>Ručne satove poznatih brendova (Rolex, Omega, Cartier...)</li>
            <li>Zlatne i srebrne satove – stari i novi modeli</li>
            <li>Kolekcionarske i limitirane serije</li>
            <li>Mehaničke i automatske satove</li>
            <li>Antikvitetne džepne satove</li>
          </ul>

          <h2><FaCrown className={styles.icon}/> Zlato</h2>
          <ul>
            <li>Zlatni nakit (ogrlice, narukvice, prstenje...)</li>
            <li>Lomljeno zlato i neispravan nakit</li>
            <li>Zlatne poluge i pločice</li>
            <li>Zlatne predmete (upaljači, satovi, okvir za naočare...)</li>
            <li>Investiciono zlato i kolekcije</li>
          </ul>

          <h2><GiSilverBullet className={styles.icon}/> Srebro</h2>
          <ul>
            <li>Srebrni nakit svih oblika</li>
            <li>Lomljeno srebro</li>
            <li>Srebrne poluge i pločice</li>
            <li>Pribor za jelo, poslužavnici</li>
            <li>Antikvitetni srebrni predmeti</li>
          </ul>

          <h2><GiDiamonds className={styles.icon}/> Dijamanti</h2>

          <h2><FaPenFancy className={styles.icon}/> Naliv-pera i upaljači</h2>
          <ul>
            <li>Luksuzna naliv-pera (Montblanc, Parker, Cartier...)</li>
            <li>Kolekcionarska i limitirana izdanja</li>
            <li>Upaljače poznatih brendova (Dupont, Dunhill, Zippo...)</li>
          </ul>

          <h2><FaMedal className={styles.icon}/> Ordenja i medalje</h2>
          <ul>
            <li>Vojna odlikovanja i značke</li>
            <li>Državne medalje</li>
            <li>Sportske nagrade od plemenitih metala</li>
            <li>Kolekcionarska ordenja</li>
          </ul>

          <h2><FaCoins className={styles.icon}/> Zlatnici i star novac</h2>
          <ul>
            <li>Zlatnike (carski, kraljevski, austrougarski...)</li>
            <li>Srebrnjake i kovanice</li>
            <li>Antički i srednjovekovni novac</li>
            <li>Numizmatičke kolekcije</li>
          </ul>

          <h2><FaRing className={styles.icon}/> Stari nakit</h2>
          <ul>
            <li>Antikvitetni nakit od zlata i srebra</li>
            <li>Porodične kolekcije nakita</li>
            <li>Neobičan i ručno rađen nakit</li>
            <li>Nakit sa dragim kamenjem (dijamanti, rubini...)</li>
          </ul>

          <h2><GiStonePile className={styles.icon}/> Druge starine</h2>
          <ul>
            <li>Antikvitete i umetničke predmete</li>
            <li>Kolekcionarske statue, figurice, minijature</li>
            <li>Predmete od plemenitih metala</li>
            <li>Raritete i unikatne predmete sa kolekcionarskom vrednošću</li>
          </ul>
        </motion.div>
      </div>
    </div>
  );
}
